import { Flex, Icon } from "@chakra-ui/react";
import CDS from "design-system";
import BaselineCheckOutline from "components/Icon/Iconify/BaselineCheckOutline";
import { FiX } from "react-icons/fi";

interface ExistsProps {
  labelYes: string;
  labelNo: string;
  condition: boolean;
}

export function ExistsRight({ labelYes, labelNo, condition }: ExistsProps) {
  return (
    <Flex align="center" gap="2">
      <CDS.Text12 fontWeight="medium" color="chakra-body-text">
        {condition ? labelYes : labelNo}
      </CDS.Text12>
      {condition ? (
        <BaselineCheckOutline color="successGreen.DEFAULT" aria-label="Yes" />
      ) : (
        <FiX color="caminoNewErrorRed.DEFAULT" aria-label="Check No" />
      )}
    </Flex>
  );
}

export function ExistsLeft({ labelYes, labelNo, condition }: ExistsProps) {
  return (
    <Flex align="center" gap={condition ? "1" : "3px"}>
      {condition ? (
        <BaselineCheckOutline color="successGreen.DEFAULT" aria-label="Yes" />
      ) : (
        <Icon as={FiX} color="caminoNewErrorRed.DEFAULT" aria-label="Check No" />
      )}
      <CDS.Text12 fontWeight="medium" color="chakra-body-text">
        {condition ? labelYes : labelNo}
      </CDS.Text12>
    </Flex>
  );
}
